import { useInstance, createRef, onBeforeUnmount, nextTick } from 'intact-vue';
import { useState } from '../../hooks/useState';
import { clamp } from '../utils';
export function useArrow() {
  var instance = useInstance();
  var arrowType = useState(null);
  var arrowRef = createRef();
  instance.dropdown.on('positioned', updateArrow);
  onBeforeUnmount(function () {
    instance.dropdown.off('positioned', updateArrow);
  });
  function updateArrow(feedback) {
    if (!instance.dropdown.get('showArrow')) return;
    arrowType.set(feedback[feedback.important]);
    // we must calcuate style after set arrow type and view has updated
    nextTick(function () {
      if (instance.$unmounted) return;
      var arrow = arrowRef.value;
      var target = feedback.target,
        element = feedback.element;
      if (feedback.important === 'vertical') {
        var arrowWidth = arrow.offsetWidth;
        var left;
        // if (feedback.horizontal === 'center') {
        // left = (element.width - arrowWidth) / 2;
        // } else {
        left = target.left - element.left + (target.width - arrowWidth) / 2;
        // }
        left = clamp(left, 1, element.width - 1 - arrowWidth);
        arrow.setAttribute('style', "left: " + left + "px");
      } else {
        var arrowHeight = arrow.offsetHeight;
        var top;
        // if (feedback.vertical === 'center') {
        // top = (element.height - arrowHeight) / 2;
        // } else {
        top = target.top - element.top + target.height / 2 - arrowHeight / 2;
        // }
        top = clamp(top, 1, element.height - 1 - arrowHeight);
        arrow.setAttribute('style', "top: " + top + "px");
      }
    });
  }
  return {
    arrowType: arrowType,
    arrowRef: arrowRef
  };
}